export const initialFormState =  {
        amount: undefined,
        city: "",
        country: "",
        donationRhythm: 0,
        donationType: 0,
        email: "",
        firstname: "",
        gift: false,
        newsletter: false,
        paymentMethod: undefined,
        salutation: "",
        sponsorshipType: 0,
        street: "",
        surname: "",
        zip: "",
}
